// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import StoreCartState from "@store/Framework/Store/Pages/Cart/StoreCartState";
import { OrderReasonsModel } from "@store/Framework/Types/ApiModels";
import { Draft } from "immer";

const initialState: StoreCartState = {
    requestOutOfCycleOrder: false,
};

const actions = {
    "store/Pages/Cart/SetRequestOutOfCycle": (
        draft: Draft<StoreCartState>,
        action: { requestOutOfCycleOrder: boolean },
    ) => {
        draft.requestOutOfCycleOrder = action.requestOutOfCycleOrder;
    },
    "store/Pages/Cart/SetOrderReason": (draft: Draft<StoreCartState>, action: { orderReason: OrderReasonsModel }) => {
        draft.orderReason = action.orderReason;
    },
    "store/Pages/Cart/ResetOrderReason": (draft: Draft<StoreCartState>) => {
        if (draft.orderReason) {
            delete draft.orderReason;
        }
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type StoreCartActions = Parameters<typeof reducer>[1];
export default reducer;
